import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Login, Register } from '../_model/login';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

constructor(private http: HttpClient) { }

baseUrl: string = "https://"+environment.apiUrl+"/api/auth/";

login(model: Login) {
  return this.http.post(this.baseUrl+"login", model)
    .pipe(
      map((data: any) => {
        return data;
      })
    );
}
callCheck(id: string) {
  return this.http.post(this.baseUrl+"validate",{id:id}).toPromise();
}
asCredencials(): boolean {
  var userId = localStorage.getItem("userId");
  return userId != null && userId != undefined;
}
async loggedIn(): Promise<boolean> {
  var id: any = localStorage.getItem("userId");
  if(id === null || id === undefined) {
    return new Promise<boolean>((resolve, reject) => {
      resolve(false);
    });
  }
  var result: boolean;
  await this.callCheck(id).then((data: any) => {
    result = data.result;
  });
  return new Promise<boolean>((resolve, reject) => {
    resolve(result);
  });
}
user() {
  var id = localStorage.getItem("userId");
  return this.http.post(this.baseUrl+"user", {id: id})
    .pipe(
      map((data: any) => {
        return data.result;
      })
    );
}
loggout() {
  localStorage.removeItem("userId");
  window.location.href="/";
}
email(email: string,userId: string, user: number) {
  return this.http.post(this.baseUrl+"email", {email: email, userId: userId, user: user})
    .pipe(
      map((data: any) => {
        return data.result;
      })
    )
}
list(id: string) {
  return this.http.post(this.baseUrl+"list", {id: id})
    .pipe(
      map((data: any) => {
        return data.result;
      })
    );
}
register(model: Register) {
  return this.http.post(this.baseUrl+"register", model).pipe();
}
delete(id: number, userId: string) {
  return this.http.post(this.baseUrl+"delete/"+id, {id: userId}).pipe();
}
changePassword(model: any) {
  return this.http.post(this.baseUrl+"update/password", model).pipe();
}

}
